import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { BatchMoveContainersInput } from 'src/models/batchMoveContainers';
import {
    batchMoveContainers,
    resetChildAndDestinationContainers,
    updateDestinationContainerId,
    resetBatchMovePageToRender
} from 'src/store/common-slices/batchMoveContainersSlice';
import {
    setPageToRender,
    SortContainerPages
} from 'src/store/common-slices/sortContainerSlice';
import DestinationContainerScanPage from 'src/components/pages/destination-container-scan/DestinationContainerScanPage';

const mapStateToProps = (state: RootState) => ({
    childContainers: state.BatchMoveContainers.childContainers,
    destinationContainerId: state.BatchMoveContainers.destinationContainerId,
    batchMoveMode: state.BatchMoveContainers.batchMoveMode,
    uiAlertState: state.UI.alertState,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    batchMoveContainers: (batchMoveContainersInput: BatchMoveContainersInput) => dispatch(batchMoveContainers(batchMoveContainersInput)),
    updateDestinationContainerId: (destinationContainerId: string) => dispatch(updateDestinationContainerId(destinationContainerId)),
    resetChildAndDestinationContainers: () => dispatch(resetChildAndDestinationContainers()),
    resetBatchMovePageToRender: () => dispatch(resetBatchMovePageToRender()),
    setSortationPageToRender: (pageToRender: SortContainerPages) => dispatch(setPageToRender(pageToRender)),
});

export default connect(mapStateToProps, mapDispatchToProps) (DestinationContainerScanPage);